//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { weeklySignListApi, weeklySignDeleteApi } from '@/api/marketing/sign.js';
import { appletListApi } from '@/api/operation/applet';
export default {
  data: function data() {
    return {
      loading: false,
      appList: []
    };
  },
  computed: {
    formData: function formData() {
      return [
      // { label: '用户搜索', prop: 'user', type: 'user-select-input' },
      {
        label: '所属应用',
        prop: 'applicationId',
        defaultValue: '',
        type: 'select',
        options: {
          list: this.appList
        }
      }];
    },
    columns: function columns() {
      return [{
        key: 'id',
        visible: true,
        label: "ID",
        width: 140
      }, {
        key: 'appName',
        visible: true,
        label: "\u6240\u5C5E\u5E94\u7528"
      }, {
        key: 'updateTime',
        visible: true,
        label: "\u66F4\u65B0\u65F6\u95F4",
        width: 160
      }, {
        key: 'updater',
        visible: true,
        label: "\u64CD\u4F5C\u4EBA",
        width: 100
      }];
    }
  },
  created: function created() {
    this.getAppList();
  },
  methods: {
    getAppList: function getAppList() {
      var _this = this;
      var params = {
        page: 1,
        limit: 1000
      };
      appletListApi(params).then(function (data) {
        _this.appList = (data.list || []).map(function (item) {
          item.label = item.appName;
          item.value = item.id;
          return item;
        });
      });
    },
    getList: function getList(params) {
      return weeklySignListApi(params);
    },
    //添加商品
    handleAdd: function handleAdd() {
      this.$router.push({
        path: "/marketing/sign/weekly/operate/0/add"
      });
    },
    //商品操作
    handleActivity: function handleActivity(row, operate) {
      //id:商品id，operate：操作类型(edit编辑，copy复制，detail详情不可编辑)
      this.$router.push({
        path: "/marketing/sign/weekly/operate/".concat(row.id, "/").concat(operate)
      });
    },
    handleDelete: function handleDelete(row) {
      var _this2 = this;
      this.$modal.confirm('是否确认删除？').then(function () {
        return weeklySignDeleteApi({
          id: row.id
        });
      }).then(function () {
        _this2.$refs.searchPage.refresh();
        _this2.$modal.msgSuccess('删除成功');
      }).catch(function () {});
    }
  }
};